import { CustomPageConfigurationType, CustomPageType, ICustomPageConfig } from '../../../api/custom-pages.dao';

export class CustomPageEntityConfig {
    public static getConfigByType(type: CustomPageType): CustomPageConfigurationType {
        return {
            ...CustomPageEntityConfig.defaults,
            ...CustomPageEntityConfig.defaultsPerType[type] || {}
        } as CustomPageConfigurationType;
    }

    public static get defaults(): Omit<ICustomPageConfig, 'type'> {
        return {
            label: '',
            landingPage: false,
            path: '',
            enabled: true,
            restrictAccessEnabled: false,
            restrictAccessFilters: [],
        };
    }

    private static get defaultsPerType(): Record<CustomPageType, Partial<CustomPageConfigurationType>> {
        return {
            [CustomPageType.Knovio]: { type: CustomPageType.Knovio, embedCodeId: '' },
            [CustomPageType.EmbeddedWebpage]: { type: CustomPageType.EmbeddedWebpage, embeddedWebpageUrl: '' },
            [CustomPageType.RichText]: { type: CustomPageType.RichText, richText: '' },
            [CustomPageType.EmbeddedHTML]: { type: CustomPageType.EmbeddedHTML },
            [CustomPageType.UserShowcase]: { type: CustomPageType.UserShowcase, embedCodeId: '' },
            [CustomPageType.ExternalLink]: { type: CustomPageType.ExternalLink, externalLink : '' },
            [CustomPageType.SingleMeeting]: { type: CustomPageType.SingleMeeting, meetingId : null },
            [CustomPageType.BookAMeeting]: { type: CustomPageType.BookAMeeting }
        };
    }
}
